import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import styled, { keyframes } from 'styled-components'

import server from 'server/serverController2'
import { FooterStateActions } from 'store/actionCreators'

import TitleHeader from 'components/presenters/header/TitleHeader'
import FeedItem from 'components/presenters/feed/detail/FeedItem'
import BottomTextArea from 'components/containers/input/BottomTextArea'
//Modal
import BottomModal from 'components/presenters/modal/BottomModal'
import CenterModal from 'components/presenters/modal/CenterModal'
import TaskResultFormModal from 'components/containers/task/modal/TaskResultFormModal'
import TaskReportModal from 'components/containers/task/modal/TaskReportModal'
import UserReportModal from 'components/containers/report/UserReportModal'
//image
import closeIcon from 'images/close_icon.png'
//lottieFile
import LottieLodder from 'components/containers/common/LottieLoader'
import likeAnimation from 'images/lottiefile/like_animation_red.json'
import loadingAnimation from 'images/lottiefile/yellow_loading_animation.json'
//util
import { formatDate, removeItem } from 'utils/utils'

export default function TaskDetail({
  currTaskNo,
  title = '댓글',
  animation = false,
  isCommentSlideOn,
  setIsCommentSlideOn,
  setCommentVisible,
  deleteFeedRequest = null,
  onTriggerCreateComment = null,
  onTriggerDeleteComment = null,
  onTriggerCreateLike = null,
  onTriggerDeleteLike = null,
  onTriggerUpdateTask = null,
  onDeleteTaskTrigger,
  onUserReportComplete,
  hideUserFeed,
}) {
  const userInfo = useSelector((state) => {
    return state['userInfo']
  })
  const animationClassName =
    (animation && isCommentSlideOn !== null) || isCommentSlideOn !== undefined
      ? isCommentSlideOn
        ? 'slide_on'
        : 'slide_out'
      : null

  //Task
  const [taskItem, setTaskItem] = useState(null)
  const [isTaskLoading, setIsTaskLoading] = useState(false)

  //Comment
  const [commentList, setCommentList] = useState([])
  const [commentValue, setCommentValue] = useState('')
  const [insertedCommentIndexes, setInsertedCommentIndexes] = useState([])
  const [insertedCommentList, setInsertedCommentList] = useState([])
  const [currCommentInfo, setCurrCommentInfo] = useState(null)
  const [lastCommentNo, setLastCommentNo] = useState(null)
  const [isCommentLoading, setIsCommentLoading] = useState(false)
  const [isCommentEnd, setIsCommentEnd] = useState(false)

  //BottomModal
  const [bottomModalVisible, setBottomModalVisible] = useState(false)
  const [bottomModalDataList, setBottomModalDataList] = useState([])

  //CenterModal
  const [centerModalVisible, setCenterModalVisible] = useState(false)
  const [centerModalDataList, setCenterModalDataList] = useState({})
  const [onModalComplete, setOnModalComplete] = useState(null)
  const [onModalCancel, setOnModalCancel] = useState(null)

  //Reply
  const [replyList, setReplyList] = useState([])
  const [isReplyLoading, setIsReplyLoading] = useState(false)
  const [isReplyEnd, setIsReplyEnd] = useState(false)

  //TopHeader
  const [isSlideOn, setIsSlideOn] = useState(true)

  //BottomInput
  const [currBottomInputHeight, setCurrBottomInputHeight] = useState(70)
  const [bottomInputFocus, setBottomInputFocus] = useState(false)

  //DoubleClickState
  const [clickTimeout, setClickTimeout] = useState(null)

  //Animation
  const [isLikeAnimation, setIsLikeAnimation] = useState(false)

  //TaskResultFormModal
  const [showTaskResultForm, setShowTaskResultForm] = useState(false)
  const [targetTaskNo, setTargetTaskNo] = useState(null)

  //ShowMoreDesc
  const [showMoreFeedNoList, setShowMoreFeedNoList] = useState([])
  //TaskReportModal
  const [reportModalVisible, setReportModalVisible] = useState(false)
  const [reportTargetNo, setReportTargetNo] = useState(null)
  //UserReportModal
  const [userReportModalVisible, setUserReportModalVisible] = useState(false)
  const [userReportTargetNo, setUserReportTargetNo] = useState(null)

  const history = useHistory()

  useEffect(() => {
    let closeTaskDetailOnBack = (event) => {
      setIsSlideOn(false)
      setIsCommentSlideOn(false)
      setReplyList(null)
      setTimeout(() => {
        setCommentVisible(false)
      }, 100)
    }
    if (animation) {
      window.history.pushState(null, document.title, window.location.href)
      window.addEventListener('popstate', closeTaskDetailOnBack)
    }

    return () => {
      if (animation) {
        window.removeEventListener('popstate', closeTaskDetailOnBack)
      }

      FooterStateActions.updateFooterState({ visible: true })
    }
  }, [])
  const handleBack = () => {
    if (!animation) {
      if (history.length > 1) {
        let prevPath = history.location
        history.goBack()
        setTimeout(() => {
          let newPath = history.location
          if (prevPath === newPath) {
            history.replace('/')
          }
        }, 100)
      } else {
        history.replace('/')
      }
    } else {
      history.goBack()
      setIsSlideOn(false)
      setIsCommentSlideOn(false)
      setReplyList(null)
      setTimeout(() => {
        setCommentVisible(false)
      }, 200)
    }
    FooterStateActions.updateFooterState({ visible: true })
  }

  const handleFormHeightChange = (height) => {
    setCurrBottomInputHeight(height)
  }

  const handleChange = (value) => {
    setCommentValue(value)
  }

  const handleClickComment = () => {
    setBottomInputFocus(true)
  }

  const handleDoubleClick = (currTask) => {
    if (clickTimeout !== null) {
      clearTimeout(clickTimeout)
      if (currTask['liked_task'] === false) {
        handleAddLike(currTask)
        setClickTimeout(null)
        return
      }
    } else {
      setClickTimeout(
        setTimeout(() => {
          clearTimeout(clickTimeout)
          setClickTimeout(null)
        }, 500),
      )
    }
  }
  //Comment
  const onSubmit = async () => {
    try {
      if (commentValue.trim() === '') {
        return
      }
      const body = {
        content: commentValue,
      }
      if (currCommentInfo !== null) {
        onReplySubmit()
        return
      }
      const resultData = await server.postRequestData(`tasks/${taskItem['task_no']}/comments`, body)
      if (resultData['success'] !== 1) {
        return
      }

      const { inserted_item } = resultData['data']
      const task = Object.assign({}, taskItem)

      if (task['total_comment'] === null) {
        task['total_comment'] = 0
      }
      task['total_comment'] = parseInt(task['total_comment']) + 1
      inserted_item['nickname'] = userInfo['name']
      inserted_item['profile_img'] = userInfo['profile_img']
      setInsertedCommentIndexes([inserted_item['no'], ...insertedCommentIndexes])
      setInsertedCommentList([inserted_item, ...insertedCommentList])
      setTaskItem(task)
      if (onTriggerCreateComment !== null) {
        onTriggerCreateComment(task['task_no'])
      }
      setCommentValue('')
    } catch (err) {
      console.log(err)
    }
  }

  const handleAddLike = async (currTask) => {
    try {
      if (userInfo['isLogin'] === false) {
        return
      }
      const resultData = await server.postRequestData(`tasks/${currTask['task_no']}/like`)
      if (resultData['success'] !== 1) {
        return
      }
      setIsLikeAnimation(true)
      const { inserted_item } = resultData['data']
      const task = Object.assign({}, taskItem)

      if (task['task_no'] === inserted_item['task_no']) {
        task['total_like'] = parseInt(task['total_like']) + 1
        task['liked_task'] = true
      }
      if (onTriggerCreateLike !== null) {
        onTriggerCreateLike(task['task_no'])
      }
      setTaskItem(task)
      setTimeout(() => {
        setIsLikeAnimation(false)
      }, 1500)
    } catch (err) {
      console.log(err)
    }
  }

  const handleDeleteLike = async (currTask) => {
    try {
      const resultData = await server.deleteRequestData(`tasks/${currTask['task_no']}/like`)
      if (resultData['success'] !== 1) {
        return
      }
      const { deleted_item } = resultData['data']
      const task = Object.assign({}, taskItem)
      if (task['task_no'] === deleted_item[0]['task_no']) {
        task['total_like'] = parseInt(task['total_like']) - 1
        task['liked_task'] = false
      }
      if (onTriggerDeleteLike !== null) {
        onTriggerDeleteLike(task['task_no'])
      }
      setTaskItem(task)
    } catch (err) {
      console.log(err)
    }
  }

  const onCommentDelete = async (currComment) => {
    try {
      const resultData = await server.deleteRequestData(`tasks/comments/${currComment['no']}`)
      if (resultData['success'] !== 1) {
        return
      }
      const { deleted_item } = resultData['data']

      if (insertedCommentIndexes.includes(deleted_item[0]['no'])) {
        const index = insertedCommentIndexes.indexOf(deleted_item[0]['no'])
        const reloadCommentList = removeItem(insertedCommentList, index)
        const reloadCommentIndexes = removeItem(insertedCommentIndexes, index)
        setInsertedCommentIndexes(reloadCommentIndexes)
        setInsertedCommentList(reloadCommentList)
      }

      const task = Object.assign({}, taskItem)
      task['total_comment'] = parseInt(taskItem['total_comment']) - 1
      let index = null
      for (let i = 0; i < commentList.length; ++i) {
        if (commentList[i]['no'] === deleted_item[0]['no']) {
          index = i
        }
      }
      if (index !== null) {
        const reloadComments = removeItem(commentList, index)
        setCommentList(reloadComments)
      }
      setTaskItem(task)
      if (onTriggerDeleteComment !== null) {
        onTriggerDeleteComment(task['task_no'])
      }
      setBottomModalVisible(false)
    } catch (err) {
      console.log(err)
    }
  }

  const handleCommentDeleteBottomModal = (currComment) => {
    if (userInfo['role'] === 'admin' || userInfo['id'] === currComment['user_no']) {
      setBottomModalDataList([
        {
          type: 'callback',
          text: '삭제',
          callback: () => onCommentDelete(currComment),
          style: { color: '#DE0000' },
        },
      ])
      setBottomModalVisible(true)
    }
  }
  //CommentEnd
  //Reply
  const onReplySubmit = () => {
    const commentNo = currCommentInfo['no']
    const body = {
      task_no: taskItem['task_no'],
      content: commentValue,
      type: ' normal',
    }

    server.postRequestData(`tasks/comments/${commentNo}/reply`, body, (res) => {
      try {
        if (res['success'] !== 1) {
          return
        }
        const { inserted_item } = res['data']
        inserted_item['nickname'] = userInfo['name']
        inserted_item['profile_img'] = userInfo['profile_img']

        if (replyList === null) {
          setReplyList({})
        } else if (replyList[inserted_item['comment_no']]) {
          const prevReplyList = Object.assign({}, replyList)
          const reloadReplyList = [...prevReplyList[inserted_item['comment_no']], inserted_item]
          prevReplyList[inserted_item['comment_no']] = reloadReplyList

          setReplyList(prevReplyList)
        }
        if (insertedCommentList.length !== 0) {
          const insertedComments = [...insertedCommentList]
          insertedComments.map((item) => {
            if (item['no'] === inserted_item['comment_no']) {
              item['total_reply'] = item['total_reply'] ? parseInt(item['total_reply']) + 1 : 1
            }
            setInsertedCommentList(insertedComments)
            return null
          })
        }
        const comments = [...commentList]
        comments.map((commentItem) => {
          if (commentItem['no'] === inserted_item['comment_no']) {
            commentItem['total_reply'] =
              commentItem['total_reply'] !== null ? parseInt(commentItem['total_reply']) + 1 : 1
          }
          return null
        })

        setCommentList(comments)
        setCommentValue('')
        setCurrCommentInfo(null)
      } catch (err) {
        console.log(err)
      }
    })
  }

  const onReplyClick = (currComment) => {
    setBottomInputFocus(true)
    setCommentValue('')
    setCurrCommentInfo(currComment)
  }

  const onReplyCancel = () => {
    setCurrCommentInfo(null)
  }

  const handleShowReply = (currComment) => {
    if (replyList !== null && replyList[currComment['no']]) {
      const prevReplyList = Object.assign({}, replyList)
      delete prevReplyList[currComment['no']]
      setReplyList(prevReplyList)
      return
    }
    server.getRequestData(`tasks/comments/${currComment['no']}/reply?order=desc&limit=5`, (res) => {
      try {
        if (res['success'] !== 1) {
          return
        }

        const { replies } = res['data']
        const reverseReplies = replies.reverse()
        const reply = {}

        for (let i = 0; i < reverseReplies.length; ++i) {
          if (!reply[reverseReplies[i]['comment_no']]) {
            reply[reverseReplies[i]['comment_no']] = [reverseReplies[i]]
            continue
          }
          reply[reverseReplies[i]['comment_no']] = [
            ...reply[reverseReplies[i]['comment_no']],
            reverseReplies[i],
          ]
        }
        const prevReplyList = Object.assign({}, replyList)
        const replyResult = replyList ? Object.assign(prevReplyList, reply) : reply
        setReplyList(replyResult)
      } catch (err) {
        console.log(err)
      }
    })
  }

  const handleNextLoadReply = (currCommentNo) => {
    if (isReplyLoading || isReplyEnd) return
    setIsReplyLoading(true)
    const lastReplyNo = replyList[currCommentNo][0]['no']
    server.getRequestData(
      `tasks/comments/${currCommentNo}/reply?order=desc&limit=5&last_pos_no=${lastReplyNo}`,
      (res) => {
        try {
          if (res['success'] !== 1) {
            return
          }
          const { replies } = res['data']
          if (replies.length > 0) {
            const prevReplyList = Object.assign({}, replyList)
            const reverseRelies = replies.reverse()
            prevReplyList[currCommentNo] = [...reverseRelies, ...prevReplyList[currCommentNo]]
            setReplyList(prevReplyList)
          } else {
            setIsReplyEnd(true)
          }
          setIsReplyLoading(false)
        } catch (err) {
          console.log(err)
        }
      },
    )
  }

  const onReplyDelete = async (currReply) => {
    try {
      const resultData = await server.deleteRequestData(`tasks/comments/${currReply['no']}/reply`)
      if (resultData['success'] !== 1) {
        return
      }
      const { deleted_item } = resultData['data']

      const prevReplyList = Object.assign({}, replyList)
      const currReplyList = prevReplyList[deleted_item['comment_no']]

      let index = null
      for (let i = 0; i < currReplyList.length; ++i) {
        if (currReplyList[i]['no'] === deleted_item['no']) {
          index = i
        }
      }
      if (index !== null) {
        const reloadReplyList = removeItem(currReplyList, index)
        prevReplyList[deleted_item['comment_no']] = reloadReplyList
        if (commentList.length !== 0) {
          const comments = [...commentList]
          comments.map((commentItem) => {
            if (commentItem['no'] === deleted_item['comment_no']) {
              commentItem['total_reply'] = commentItem['total_reply']
                ? parseInt(commentItem['total_reply']) - 1
                : 0
            }
            return null
          })
          setCommentList(comments)
        }
        setReplyList(prevReplyList)
      }
      setBottomModalVisible(false)
    } catch (err) {
      console.log(err)
    }
  }

  const handleReplyDeleteBottomModal = (currReply) => {
    if (userInfo['role'] === 'admin' || userInfo['id'] === currReply['user_no']) {
      setBottomModalDataList([
        {
          type: 'callback',
          text: '삭제',
          callback: () => onReplyDelete(currReply),
          style: { color: '#DE0000' },
        },
      ])
      setBottomModalVisible(true)
    }
  }
  //ReplyEnd
  //DeleteTask
  const onDeleteTask = async (currTask) => {
    try {
      const resultData = await server.deleteRequestData(`tasks/${currTask['task_no']}/result`)
      if (resultData['success'] !== 1) {
        if (resultData['error']['res_data']['err_code'] === 'DATA_NOT_EXISTS') {
          setCenterModalDataList({
            type: 'callback',
            description: '존재하지 않는 게시물이에요',
          })
          setOnModalCancel(null)
          setOnModalComplete(() => () => handleBack())
        }
        return
      }
      handleBack()
    } catch (err) {
      console.log(err)
    }
  }

  const handleOpenReportModal = (currentFeed) => {
    setReportTargetNo(currentFeed['task_no'])
    setReportModalVisible(true)
    setBottomModalVisible(false)
  }

  const handleOpenUserReportModal = (currTask) => {
    setUserReportTargetNo(currTask['user_no'])
    setUserReportModalVisible(true)
    setBottomModalVisible(false)
  }

  const handleTaskDeleteBottomModal = (currTask) => {
    const optionMenu = []
    if (userInfo['role'] === 'admin' || userInfo['id'] === currTask['user_no']) {
      if (currTask['task_date'] >= formatDate()) {
        // optionMenu.push({
        // 	type: "callback",
        // 	text: "게시물 수정",
        // 	callback: () => {
        // 		setBottomModalVisible(false)
        // 		setTargetTaskNo(currTask["task_no"])
        // 		setShowTaskResultForm(true)
        // 	},
        // 	style: { color: "#000000" },
        // })
      }
      optionMenu.push({
        type: 'callback',
        text: '게시물 삭제',
        callback: () => handleTaskDeleteCenterModal(currTask),
        style: { color: '#DE0000' },
      })
    } else {
      optionMenu.push({
        type: 'callback',
        text: '인증샷 신고',
        callback: () => handleOpenReportModal(currTask),
        style: { color: '#DE0000' },
      })
      optionMenu.push({
        type: 'callback',
        text: '유저 신고',
        callback: () => handleOpenUserReportModal(currTask),
        style: { color: '#DE0000' },
      })
    }
    setBottomModalDataList(optionMenu)
    setBottomModalVisible(true)
  }

  const handleTaskDeleteCenterModal = (currTask) => {
    setCenterModalDataList({
      type: 'callback',
      title: '게시물 삭제',
      description: '게시물을 삭제하시겠어요?\n적립된 포인트와\n스티커도 함께 사라져요.',
    })
    setOnModalComplete(() => () => {
      if (!deleteFeedRequest) {
        onDeleteTask(currTask)
        return
      }
      handleBack()
      deleteFeedRequest(currTask['task_no'])
    })
    setOnModalCancel(() => () => setCenterModalVisible(false))
    setCenterModalVisible(true)
    setBottomModalVisible(false)
  }

  //Infinitiscroll
  const handleScroll = (e) => {
    // console.log(isCommentLoading)
    if (e.target.scrollHeight - e.target.scrollTop - 100 <= e.target.clientHeight) {
      if (isCommentLoading || isCommentEnd) return
      setIsCommentLoading(true)
      server.getRequestData(
        `tasks/${taskItem['task_no']}/comments?limit=10&last_pos_no=${lastCommentNo}`,
        commentInitCallback,
      )
    }
  }

  const taskInitCallback = (res) => {
    try {
      if (res['success'] !== 1) {
        if (res['error']['res_data']['err_code'] === 'DATA_NOT_EXISTS') {
          setCenterModalDataList({
            type: 'redirect',
            description: '존재하지 않는 게시물이에요',
            path: '/',
          })
        }
        setCenterModalVisible(true)
        return
      }
      if (!res?.data?.task) {
        setCenterModalDataList({
          type: 'redirect',
          description: '삭제되거나 존재하지 않는 게시물이에요',
          path: '/',
        })
        setCenterModalVisible(true)
        return
      }
      const task = res['data']['task']
      task['is_show_desc'] = true
      const showMoreNoList = [task['no']]

      setShowMoreFeedNoList(showMoreNoList)
      setTaskItem(task)
      setIsTaskLoading(false)
    } catch (err) {
      console.log(err)
    }
  }

  const commentInitCallback = (res) => {
    try {
      if (res['success'] !== 1) {
        return
      }
      let { comments } = res['data']

      if (comments.length > 0) {
        if (insertedCommentIndexes?.length > 0)
          for (let i = 0; i < insertedCommentIndexes.length; ++i) {
            let insertedNo = insertedCommentIndexes[i]
            for (let j = 0; j < comments.length; ++j) {
              if (parseInt(comments[j]['no']) === parseInt(insertedNo)) {
                comments = removeItem(comments, j)
              }
            }
          }
      }

      if (comments.length > 0) {
        setCommentList([...commentList, ...comments])
        setLastCommentNo(comments[comments.length - 1]['no'])
      } else {
        setIsCommentEnd(true)
      }
      setIsCommentLoading(false)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (!userInfo['isLogin']) {
      setCenterModalDataList({
        type: 'redirect',
        description: '로그인이 필요해요',
        path: '/social',
      })
      setCenterModalVisible(true)
      return
    }
    if (currTaskNo) {
      if (isTaskLoading) return
      setIsTaskLoading(true)
      server.getRequestData(`tasks/${currTaskNo}/result`, taskInitCallback)
    }
    FooterStateActions.updateFooterState({ visible: false })
  }, [])

  useEffect(() => {
    if (taskItem && commentList.length === 0) {
      if (isCommentLoading || isCommentEnd) return
      setIsCommentLoading(true)
      server.getRequestData(`tasks/${taskItem['task_no']}/comments?limit=10`, commentInitCallback)
    }
  }, [taskItem])

  const likeLottieOptions = {
    loop: false,
    autoplay: true,
    renderer: 'svg',
    animationData: likeAnimation,
  }

  const loadingLottieOptions = {
    loop: true,
    autoplay: true,
    renderer: 'svg',
    animationData: loadingAnimation,
  }
  return (
    <>
      {userInfo['isLogin'] ? (
        <TaskDetailSection className={animationClassName}>
          <FixedTopNav>
            <TitleHeader
              title={title}
              onBackBtn={handleBack}
              animation={animation}
              isSlideOn={isSlideOn}
            />
          </FixedTopNav>
          {isTaskLoading || !taskItem ? (
            <LoadingBlock>
              <LottieLodder
                lottieOptions={loadingLottieOptions}
                style={{ width: 'calc(100vw * (60 / 375))' }}
              />
            </LoadingBlock>
          ) : (
            <TaskItemSection onScroll={handleScroll}>
              <FeedItem
                feedItem={taskItem}
                userInfo={userInfo}
                commentList={commentList}
                insertedCommentList={insertedCommentList}
                handleCommentBottomModal={handleCommentDeleteBottomModal}
                replyList={replyList}
                onReplyClick={onReplyClick}
                handleShowReply={handleShowReply}
                handleNextLoadReply={handleNextLoadReply}
                handleReplyDeleteBottomModal={handleReplyDeleteBottomModal}
                handleDoubleClick={handleDoubleClick}
                addLikeRequest={handleAddLike}
                deleteLikeRequest={handleDeleteLike}
                isLikeAnimation={isLikeAnimation}
                lottieOptions={likeLottieOptions}
                handleBottomModalState={handleTaskDeleteBottomModal}
                onClickComment={handleClickComment}
                currentFeedNo={currTaskNo}
                showMoreFeedNoList={showMoreFeedNoList}
                isDetailItem={true}
              />
            </TaskItemSection>
          )}

          {currCommentInfo ? (
            <ReplyStateSection>
              <ReplyStateBlock>{currCommentInfo['nickname']}님에게 답글 남기는 중</ReplyStateBlock>
              <ReplyCancelBlock>
                <ReplyCancelButton onClick={onReplyCancel}>
                  <ReplyCancelImg src={closeIcon} />
                </ReplyCancelButton>
              </ReplyCancelBlock>
            </ReplyStateSection>
          ) : null}
          <BottomInputSection height={currBottomInputHeight}>
            <BottomTextArea
              maxRow={5}
              minRow={1}
              textAreaStyle={{ lineHeight: '20px' }}
              onSubmit={onSubmit}
              onChange={handleChange}
              onHeightChange={handleFormHeightChange}
              bottomInputFocus={bottomInputFocus}
            />
          </BottomInputSection>
        </TaskDetailSection>
      ) : null}
      <BottomModal
        visible={bottomModalVisible}
        setVisible={setBottomModalVisible}
        dataList={bottomModalDataList}
      />
      <CenterModal
        modalVisible={centerModalVisible}
        dataList={centerModalDataList}
        onComplete={onModalComplete}
        onCancel={onModalCancel}
      />
      <TaskResultFormModal
        visible={showTaskResultForm}
        taskNo={targetTaskNo}
        onSubmit={(response) => {
          const targetTask = response['data']
          const newTask = Object.assign({}, taskItem)
          newTask['description'] = targetTask['description']
          newTask['proof'] = response['data']['proof']
          if (onTriggerUpdateTask) {
            onTriggerUpdateTask(newTask['task_no'], newTask['proof'], newTask['description'])
          }
          setTaskItem(newTask)
          setShowTaskResultForm(false)
          setTargetTaskNo(null)
        }}
        onClose={() => {
          setShowTaskResultForm(false)
          setTargetTaskNo(null)
        }}
      />
      {reportModalVisible && reportTargetNo ? (
        <TaskReportModal
          visible={reportModalVisible}
          setVisible={setReportModalVisible}
          reportTargetNo={reportTargetNo}
          setReportTargetNo={setReportTargetNo}
          onDeleteTaskTrigger={onDeleteTaskTrigger}
          handleBack={handleBack}
        />
      ) : null}
      <UserReportModal
        userReportModalVisible={userReportModalVisible}
        setUserReportModalVisible={setUserReportModalVisible}
        userReportTargetNo={userReportTargetNo}
        setUserReportTargetNo={setUserReportTargetNo}
        onUserReportComplete={onUserReportComplete}
        hideUserFeed={hideUserFeed}
        handleBack={handleBack}
      />
    </>
  )
}

const slideOn = keyframes`
    from {
        right: -100%;
        left: 100%;
    }
    to {
        right: 0%;
        left: 0%;
    }
`

const slideOut = keyframes`
    from {
        right: 0%;
        left: 0%;
    }
    to {
        right: -100%;
        left: 100%;
    }
`

const TaskDetailSection = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  background: #fff;
  overflow-y: hidden;
  z-index: 500;

  &.slide_on {
    animation: 0.2s ease 0s 1 normal none running ${slideOn};
  }

  &.slide_out {
    animation: ${slideOut} 0.2s;
  }
`

const FixedTopNav = styled.div`
  flex: 0 1 auto;
  min-height: calc(100vw * (51 / 375));
  height: calc(100vw * (51 / 375));
`

const LoadingBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  wight: 100%;
`

const TaskItemSection = styled.div`
  flex: 1 1 auto;
  height: 100%;
  overflow-y: scroll;
`

const ReplyStateSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: calc(100vw * (15 / 375)) calc(100vw * (15 / 375));

  background: #f0f0f1;
`

const ReplyStateBlock = styled.div`
  font-size: calc(100vw * (14 / 375));
  color: #8c8f94;
`

const ReplyCancelBlock = styled.div`
  width: calc(100vw * (12 / 375));
  height: calc(100vw * (12 / 375));
`

const ReplyCancelButton = styled.button`
  width: 100%;
  height: 100%;
`

const ReplyCancelImg = styled.img`
  corver: object-fit;
`

const BottomInputSection = styled.div`
  min-height: ${({ height }) => height}px;
  padding: calc(100vw * (15 / 375)) calc(100vw * (17 / 375)) calc(100vw * (14 / 375))
    calc(100vw * (16 / 375));
  flex: 0 1 auto;
`
